// Libraries
import React from 'react';
// Views
import QuickFilter from './QuickFilter';
import StatusSelector from './StatusSelector';

export function HeaderLegend(props) {
  const { needsCnCount, needsContactCount } = props;

  return (
    <div className="ccm-status-legend box-wrapper d-flex mt-2">
      <StatusSelector />
      <QuickFilter
        needsCnCount={needsCnCount}
        needsContactCount={needsContactCount}
      />
    </div>
  );
}

export default HeaderLegend;
